import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton, Drawer, Space } from "antd";
import {  useParams } from "react-router-dom";
import OtherErrors from "@general/otherErrors";
import moment from "moment-jalaali";
import AdminHolidaysListTable from "./table";
import HolidaysTableDetails from "./tableDetails";
import TableFilters from "@general/tableFilters";
import getWindowSize from "@utils/windowSize";
const GETHOLIDAYS = gql`
  query ($paginateInput: PaginateInput!, $searchInput: HolidaySearchInput!) {
    getHolidaysCount(searchInput: $searchInput)
    getHolidays(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      createdAt
      workAt
      startTime
      endTime
      contract
      user {
        id
        name
        mobile
      }
    }
  }
`;

function AdminAllUsersHolidays(props) {
  const [tableData, setTableData] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [sortDir, setSortDir] = useState("desc");
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [filterDateFrom, setFilterDateFrom] = useState(null);
  const [filterDateTo, setFilterDateTo] = useState(null);
  const [filterSearchHoliday, setFilterSearchHoliday] = useState("");
  const [drawer, setDrawer] = useState(false);

  const windowSize = getWindowSize().innerWidth;

  const [getHolidays, holidays] = useLazyQuery(GETHOLIDAYS, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setTableData(data);
    },
  });

  const { result } = useParams();
  useEffect(() => {
    getHolidays({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {
          userId: result !== "all" ? result : null,
          createdAt:
            filterDateFrom && filterDateTo
              ? [filterDateFrom, filterDateTo]
              : null,
          textSearch: filterSearchHoliday,
        },
      },
    });
  }, [currentPage, sortDir, filterDateTo, filterSearchHoliday]);

  const pageChange = (current) => {
    setCurrentPage(current);
  };

  const sort = (sortData) => {
    setCurrentPage(1);
    setSortColumn(sortData.columnKey);
    if (sortData.order === "ascend") setSortDir("asc");
    if (!sortData.order || sortData.order === "descend") setSortDir("desc");
  };

  const filterDate = (dates, dateString) => {
    setCurrentPage(1);
    if (dateString[0] === "" || dateString[1] === "") {
      setFilterDateFrom(null);
      setFilterDateTo(null);
    } else {
      setFilterDateFrom(
        moment(dateString[0], "jYYYY/jMM/jDD")
          .startOf("day")
          .toDate()
          .toISOString()
      );
      setFilterDateTo(
        moment(dateString[1], "jYYYY/jMM/jDD")
          .endOf("day")
          .toDate()
          .toISOString()
      );
    }
  };

  const filterSearch = (phrase) => {
    setCurrentPage(1);
    setFilterSearchHoliday(phrase);
  };

  const openDrawer = (id, name) => {
    setDrawer({ id, name });
  };
  const closeDrawer = () => {
    setDrawer(false);
  };
  if (holidays.error) return <OtherErrors />;
  if (Object.keys(tableData).length === 0)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (

      <>
        <Drawer
          title="تعهدنامه"
          placement="right"
          open={drawer}
          onClose={closeDrawer}
          size={windowSize >= 750 ? "large" : null}
          width={windowSize < 750 ? windowSize - 50 : null}
        >
          <HolidaysTableDetails
            id={drawer.id}
            onCloseDrawer={closeDrawer}
          />
        </Drawer>

        <TableFilters onFilterDate={filterDate} onFilterSearch={filterSearch} />
        <Space></Space>
        <br />
        <AdminHolidaysListTable
          data={tableData}
          onSort={sort}
          onPageChange={pageChange}
          currentPage={currentPage}
          loading={holidays.loading}
          onOpenDrawer={openDrawer}
        />
      </>

  );
}

export default AdminAllUsersHolidays;
